/* ------------------------------------------------------------------
   APEX AFFAIR — Doppel-Warenkorb-Schutz  (Stand 08.09.2026)

   BEFUND (08.09.2026, live nachgestellt):
   Auf allen NICHT-deutschen Sprachpfaden (/es/, /fr/, /it/, /nl/ ...)
   loest ein einziger Klick auf "In den Warenkorb" ZWEI Requests aus:
     1. POST /es/cart/add.js  <- ProductFormComponent.handleSubmit (Theme)
     2. POST /es/cart/add.js  <- upcart-bundle.js (App "UpCart")
   Ergebnis: Menge 2 statt 1. Auf dem deutschen Hauptpfad ist es
   korrekt genau ein Request. UpCart unterdrueckt den Theme-Request
   offenbar nur auf dem Standard-Pfad und greift bei uebersetzten
   Pfaden daneben.

   Diese Datei ist eine BRUECKE, keine Loesung: Sie erkennt einen
   zweiten, identischen Add-Request innerhalb von 1,5 Sekunden und
   gibt dem zweiten Aufrufer die Antwort des ersten zurueck, statt
   erneut zu buchen. Die eigentliche Reparatur gehoert in die
   UpCart-Einstellungen bzw. zum UpCart-Support.

   Entfernen = die eine <script>-Zeile in layout/theme.liquid loeschen.
------------------------------------------------------------------ */
(function () {
  'use strict';

  if (!window.fetch || window.__apexCartGuard) return;
  window.__apexCartGuard = true;

  var WINDOW_MS = 1500;
  var origFetch = window.fetch;
  var last = null;

  /* Theme schickt einen relativen, UpCart einen absoluten Pfad —
     daher immer auf den reinen Pfad normalisieren. */
  function pathOf(url) {
    try { return new URL(String(url), window.location.href).pathname; }
    catch (e) { return String(url).split('?')[0]; }
  }

  function isAddUrl(url) {
    return /\/cart\/add(\.js)?$/.test(pathOf(url));
  }

  /* Variante + Menge aus jedem gaengigen Body-Format ziehen.
     Wichtig: das Format darf NICHT in die Signatur einfliessen —
     das Theme schickt FormData, UpCart schickt JSON. */
  function sig(id, qty) {
    return String(id) + 'x' + String(qty || 1);
  }

  function signature(body) {
    try {
      if (!body) return 'empty';
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        return sig(body.get('id'), body.get('quantity'));
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        return sig(body.get('id'), body.get('quantity'));
      }
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') {
          var j = JSON.parse(body);
          var it = (j.items && j.items[0]) || j;
          return sig(it.id, it.quantity);
        }
        var p = new URLSearchParams(body);
        return sig(p.get('id'), p.get('quantity'));
      }
    } catch (e) {}
    return 'unknown';
  }

  window.fetch = function (input, init) {
    var url, method, body;
    try {
      url = (input && input.url) ? input.url : String(input);
      method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      body = (init && init.body) || null;
    } catch (e) {
      return origFetch.apply(this, arguments);
    }

    if (method !== 'POST' || !isAddUrl(url)) {
      return origFetch.apply(this, arguments);
    }

    var key = pathOf(url) + '|' + signature(body);
    var now = Date.now();

    if (last && last.key === key && (now - last.t) < WINDOW_MS && last.copy) {
      /* Zweiter identischer Add -> Antwort des ersten wiederverwenden. */
      return last.copy.then(function (r) { return r.clone(); });
    }

    var p = origFetch.apply(this, arguments);
    /* Kopie SYNCHRON anlegen, bevor der Aufrufer den Body liest. */
    var copy = p.then(function (r) { return r.clone(); });
    copy['catch'](function () {});
    last = { key: key, t: now, copy: copy };
    return p;
  };
})();
